import { jsxs, jsx } from 'react/jsx-runtime';
import { useApiClient } from '../../lib/api-client.js';
import { useQuery } from '@tanstack/react-query';
import { useId } from 'react';

/**
 * Dropdown that lists all prompts for a given purpose, allowing the user to
 * override the default prompt used during AI generation actions.
 *
 * Relies on an app backend exposing `GET /prompts/by-purpose/:purpose` that
 * returns `{ success, data: Prompt[] }`.
 */
function PromptSelector({ purpose, value, onChange, label = 'Prompt Template', }) {
    const apiClient = useApiClient();
    const instanceId = useId();
    const { data, isLoading } = useQuery({
        queryKey: ['prompts', 'by-purpose', purpose],
        queryFn: () => apiClient.get(`/prompts/by-purpose/${purpose}`),
        enabled: !!purpose,
    });
    const prompts = data?.data ?? [];
    const handleChange = (e) => {
        const val = e.target.value;
        onChange(val === '' ? undefined : val);
    };
    return (jsxs("div", { children: [jsx("label", { htmlFor: instanceId, className: "block text-sm font-medium mb-1", children: label }), jsxs("select", { id: instanceId, className: "w-full px-3 py-2 border rounded-md", value: value ?? '', onChange: handleChange, disabled: isLoading, children: [jsx("option", { value: "", children: "Default" }), prompts.map((prompt) => (jsxs("option", { value: prompt.id, children: [prompt.name, prompt.isDefault ? ' (Default)' : ''] }, prompt.id)))] })] }));
}

export { PromptSelector };
//# sourceMappingURL=PromptSelector.js.map
